import { PulseApi } from '../../utilities/pulseApi.js';
import { PulseBaseProvider } from '../../base-classes/pulseBaseProvider.js';
const loggingUri = '/clog/v1/submit';

export class LoggingProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
    }

    async logEvent(eventType, params, postData, stdParameters) {
        const keyValuePairs = Object.entries(postData).map(x => {
            return { key: x[0], value: x[1] };
        });
        const logTimestampUtc = Date.now();

        const data = JSON.stringify({
            metadata: {
                ...stdParameters,
                ts: logTimestampUtc //utc timestamp in milliseconds
            },
            events: [
                {
                    type: eventType,
                    ts: logTimestampUtc,
                    data: keyValuePairs
                }
            ]
        });

        return new Promise(async (resolve, reject) => {
            try {
                const result = await super.postData(params, data, loggingUri, true);
                resolve(result);
            } catch (error) {
                reject(error);
            }
        });
    }
}
